import { render } from "./CompanyServicesShowCase.vue?vue&type=template&id=5ee8d127"
import script from "./CompanyServicesShowCase.vue?vue&type=script&lang=js"
export * from "./CompanyServicesShowCase.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./CompanyServicesShowCase.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__